export default "__VITE_ASSET__BsOraYhT__"